import React from "react";
import styled from "styled-components";
import type { IColorsInterface } from "styles/colors";
import type { IIconSizeInterface } from "styles/theme";

export interface IconProps {
  size?: string;
  iconSize?: keyof IIconSizeInterface;
  color?: keyof IColorsInterface;
}

export interface IconBaseProps extends IconProps {
  href: string;
}

const SVGBase = styled.svg<IconProps>(
  ({ theme, iconSize = "small", size = theme.iconSize[iconSize], color }) => ({
    lineHeight: "100%",
    width: size,
    height: size,
    color: color ? theme.colors[color] : undefined,
  })
);

export const IconBase = ({ href, ...rest }: IconBaseProps) => {
  return (
    <SVGBase {...rest}>
      <use href={href} width="100%" height="100%" />
    </SVGBase>
  );
};
